export default "__VITE_ASSET__C818246e__"